import { Point } from "geojson";
import { Identifier } from "react-admin";

import { ColumnsOf } from "../data";
import { Maybe } from "../utility";

export const sensorType = {
  Temperature: "temperature",
  Humidity: "humidity"
} as const;

export type SensorType = (typeof sensorType)[keyof typeof sensorType];

export interface SensorAggregate {
  id: Identifier;
  tid: Identifier;
  avg: number;
  max: number;
  min: number;
  count: number;
  last_at: string;
  since: string;
  until: string;
  type: SensorType;
  presence_id: Identifier;
  updated_at: string;
  location: Maybe<Point>;
  address: Maybe<string>;
  site_id: Maybe<Identifier>;
  site_name: Maybe<string>;
  site_position: Maybe<Point>;
  zone_id: Maybe<Identifier>;
  zone_name: Maybe<string>;
}

export interface Sensor {
  /**
   * Cloud doesn't provide ID for sensors so we have to calculate it
   * */
  id: Identifier;
  created_at: string;
  device_id: Identifier;
  tid: Identifier;
  location: Maybe<Point>;
  space_id: Maybe<Identifier>;
  reported_at: string;
  time: string;
  type: SensorType;
  unit: string;
  value: number;
}
export type Reading = Pick<SensorAggregate, "avg" | "max" | "min" | "count"> & {
  error: [number, number];
};

export type SensorAggregateGrouped = Omit<
  SensorAggregate,
  "avg" | "max" | "min" | "count" | "type"
> & {
  temperature: Maybe<Reading>;
  humidity: Maybe<Reading>;
};

export const SENSOR_COLUMNS: ColumnsOf<Sensor> = ["*"] as const;
export const SENSOR_AGGREGATE_COLUMNS: ColumnsOf<SensorAggregate> = ["*"] as const;
